import { INITIAL_JS_RESULT_PROPERTIES, type JsResultProperties } from './types'

function readBool(value: unknown): boolean {
  if (value === true || value === 'true') return true
  if (value && typeof value === 'object' && 'value' in value) {
    const v = (value as { value: unknown }).value
    return v === true || v === 'true'
  }
  return false
}

/** Maps En.getProperties() after client script to JsResultProperties (Swing JSResult.properties parity). */
export function mapEnRuntimePropertiesToJsResult(
  props: Record<string, unknown> | null | undefined,
): JsResultProperties {
  const p = props ?? {}
  return {
    ...INITIAL_JS_RESULT_PROPERTIES,
    isContext: readBool(p.isContextSet) || readBool(p.isContext),
    _success: readBool(p._success),
    cleanup_data: readBool(p.cleanup_data),
    close__after__complete: readBool(p.close__after__complete),
    return__from__dialog: readBool(p.return__from__dialog),
    retry__operation: readBool(p.isRepeatSet) || readBool(p.retry__operation),
    dispatched_visibilities: p.dispatchedVisibilities ?? p.dispatched_visibilities ?? [],
    dispatched_editables: p.dispatchedEditables ?? p.dispatched_editables ?? [],
  }
}
